import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import { Header } from '../Header'
import { Grid } from '../Grid'
import { GlobalVariables } from 'Globals/GlobalVariables'

const defaultProperties: { [key: string]: string } = {
  module: 'grid', // header / grid
}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = defaultProperties,
}): ReactElement => {
  const modules: { [key: string]: ReactElement } = {
    grid: (
      <Grid
        tenant={tenant}
        colorMode={colorMode}
      />
    ),
    header: (
      <Header
        title={'Am Ende der Welt'}
        titleMobile={'Am Ende<br />der Welt'}
        tenant={tenant}
        colorMode={colorMode}
      />
    ),
  }
  return (
    <AppContainer $colorMode={colorMode}>
        {properties.module && modules[properties.module]
        ? modules[properties.module]
        : modules[defaultProperties.module]}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
